export default __webpack_public_path__ + "static/media/react.0c7567c6.svg";